import { BackButton } from '@repo/ui';

export type ActivationBackButtonProps = {
  onBack: () => void;
  className?: string;
};

/**
 * The activation flow's back affordance. It is `@repo/ui`'s BackButton — the
 * same component, and therefore the same box and tint, as every other screen
 * — wrapped only so the flow has one import to change if that stops being
 * true, and to name the test id.
 */
export const ActivationBackButton = ({
  onBack,
  className,
}: ActivationBackButtonProps) => (
  <BackButton
    variant='button'
    goBack={onBack}
    className={className}
    testId='back-button'
  />
);
